<template>
  <div class="forgot-password">
    <div class="landing-page-wrapper">
      <div class="landing-page-content">
        <div class="forgot-password">
          <h1 class="page-title">
            <div class="content">
              Invalid token
            </div>
          </h1>
          <p class="page-description">
            Your password reset token is invalid. Please enter your email address and <br/>
            you will be sent a new one by email.
          </p>
          <div class="landing-page-login-group"
               :class="[{ 'active': formInfo.email !== '' || emailFocus, 'has-error': this.errors.has('Email') }]">
            <label for="landing-page-login-email">Email</label>
            <input id="landing-page-login-email"
                   type="email"
                   name="Email"
                   v-validate="'required|email'"
                   @focus="emailFocus = true"
                   @blur="emailFocus = false"
                   v-model="formInfo.email" />
            <span class="form-field-error" v-if="this.errors.has('Email')">{{ this.errors.first('Email') }}</span>
          </div>
          <div class="landing-page-login-actions">
            <a href="#" class="login background-1-100"
               :class="[{ 'active-logging': resetInProgress }]"
               @click.prevent="sendFormRequest()">Send me reset link</a>
          </div>
          <div class="landing-page-login-info">
            Having trouble accessing your account? <br/>
            <router-link :to="{ name: 'contact' }">Get in touch</router-link> and tell us about your problem, we’ll do our best to help you.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    name: 'invalid-token',
    data () {
      return {
        resetInProgress: false,
        formStatus: {
          shown: false,
          success: false,
          title: '',
          body: ''
        },
        emailFocus: false,
        formInfo: {
          email: ''
        }
      }
    },
    methods: {
      sendFormRequest () {
        let self = this
        this.$validator.validateAll()
        if (this.errors.items.length) return
        this.resetInProgress = true
        this.$http.post(api.URLS.forgotPassword, JSON.stringify(this.formInfo))
            .then((res) => {
              this.formStatus.success = true
              this.formStatus.title = 'Reset link successfully sent.'
              this.formStatus.body = 'If your email is in our database, you’ll receive an email shortly with instructions to reset your password.'
              this.formStatus.shown = true
              this.formInfo.email = ''
              setTimeout(function () {
                self.errors.clear()
              }, 100)
            })
            .catch((err) => {
              this.resetInProgress = false
              this.formStatus.success = false
              this.formStatus.title = err.body
              this.formStatus.body = ''
              this.formStatus.shown = true
            })
      }
    },
    created () {
      document.title = 'Clear Assured – forgot password'
    }
  }
</script>

<style src="@/assets/scss/main/landing-page.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// InvalidToken.vue?a7079cbe